import { render } from "./AdBannerEdit.vue?vue&type=template&id=19740bed&scoped=true"
import script from "./AdBannerEdit.vue?vue&type=script&lang=js"
export * from "./AdBannerEdit.vue?vue&type=script&lang=js"

import "./AdBannerEdit.vue?vue&type=style&index=0&id=19740bed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19740bed"]])

export default __exports__